export enum EMatNelzeDuvod {
    LEGAL_OBSTACLES = 'LEGAL_OBSTACLES',
    CONSENT_NOT_OBTAINED = 'CONSENT_NOT_OBTAINED',
    BINDING_LEGAL_COMMITMENTS = 'BINDING_LEGAL_COMMITMENTS',
    DETRIMENT_NOT_EXCLUDED = 'DETRIMENT_NOT_EXCLUDED',
    DISCLOSURE_DETRIMENTAL = 'DISCLOSURE_DETRIMENTAL'
}
